<joymo-capture-payment-method
  *ngIf="option"
  [title]="title"
  (onPaymentMethodIdCaptured)="buyOption($event, option)"
>
</joymo-capture-payment-method>
